import { useNavigate } from "react-router";
import { BookOpen, FolderOpen, Map, Moon, Settings, Sun, User } from "lucide-react";
import { ResponsiveSheet } from "./ResponsiveSheet";
import { useTheme } from "./ThemeProvider";

interface MobileMoreSheetProps {
  open: boolean;
  onClose: () => void;
}

const ITEMS = [
  { to: "/collections", label: "Collections", icon: FolderOpen },
  { to: "/editions", label: "Editions", icon: BookOpen },
  { to: "/map", label: "Mind Map", icon: Map },
  { to: "/u/me", label: "Profile", icon: User },
  { to: "/settings", label: "Settings", icon: Settings },
];

/** Secondary destinations on mobile — everything not in the bottom tab bar. */
export function MobileMoreSheet({ open, onClose }: MobileMoreSheetProps) {
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();

  return (
    <ResponsiveSheet open={open} onClose={onClose} label="More" zIndex={60}>
      <div className="p-4 pb-2">
        <div className="grid grid-cols-3 gap-2">
          {ITEMS.map((item) => (
            <button
              key={item.to}
              onClick={() => {
                onClose();
                navigate(item.to);
              }}
              className="flex flex-col items-center gap-2 py-4 rounded-2xl bg-background border border-border/30 text-muted-foreground hover:text-accent hover:border-accent/30 active:scale-[0.97] transition-all"
            >
              <item.icon size={20} />
              <span style={{ fontSize: "0.75rem" }}>{item.label}</span>
            </button>
          ))}
          <button
            onClick={toggleTheme}
            className="flex flex-col items-center gap-2 py-4 rounded-2xl bg-background border border-border/30 text-muted-foreground hover:text-accent hover:border-accent/30 active:scale-[0.97] transition-all"
          >
            {theme === "light" ? <Moon size={20} /> : <Sun size={20} />}
            <span style={{ fontSize: "0.75rem" }}>{theme === "light" ? "Dark mode" : "Light mode"}</span>
          </button>
        </div>
      </div>
    </ResponsiveSheet>
  );
}
